import React from 'react';
import TpAdminService from '../../../Services/TpAdminService';
import FreelancerUserManagerItem from '../../../Domain/FreelancerUserManagerItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import AddManagerWindowDescription from './AddManagerWindowDescription';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import FreelancerUserManagerEditItem from '../../../Domain/FreelancerUserManagerEditItem';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';

export default class ThirdPartySystemsAdmin extends React.Component {
  static defaultProps = {
    freelancerUser: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: { FreelancerUserId: this.props.freelancerUser.FreelancerUserId },
      shownPanel: ShownPanelsEnum.None,
    };

    this.editPanelOnClose = this.editPanelOnClose.bind(this);
    this.addManagerFunction = this.addManagerFunction.bind(this);
    FreelancerUserManagerItem.removeManagerFunction = this.removeManagerFunction.bind(this);
  }

  editPanelOnClose(refresh) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else {
      this.setState({ shownPanel: ShownPanelsEnum.None });
    }
  }

  addManagerFunction() {
    this.setState({ shownPanel: ShownPanelsEnum.AddNewItem });
  }

  removeManagerFunction(id) {
    TpAdminService.RemoveFreelancerUserManager(id)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        ErrorMessage.SetSuccess('The manager has been removed successfully.');
        this.editPanelOnClose(true);
      })
      .catch((ex) => {
        ErrorMessage.SetErrorMessage('FUMA58');
      });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderButtons() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            iconName: 'fa-solid fa-circle-plus',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.addManagerFunction(),
            tooltip: 'Add Manager',
            roleKey: 'FreelancerUser_EditAction',
            disabled: this.props.freelancerUser?.IsActive !== true,
          },
        ]}
      />
    );
  }

  renderButtonsAndPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new FreelancerUserManagerEditItem(this.props.freelancerUser)}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={AddManagerWindowDescription}
            errorCode='FUS315'
          />
        )}
        {this.renderButtons()}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={FreelancerUserManagerItem}
          serviceFunction={TpAdminService.GetTpAdminByFreelancerUserId}
          convertDBItemsFunction={TpAdminService.ConvertFreelancerDBItem}
          searchItem={this.state.searchItem}
          showSearchStrip={false}
          errorCode='FUMA26'
        />
      </div>
    );
  }
}
